import isEmpty from 'lodash/isEmpty';
import {
	ThemeDomEnum,
	DEFAULT_THEME_ID,
	resolveThemeId,
} from '../../lib/ui-theme/enums';

const LOCALE_STORAGE_KEY = 'clientBackgroundConfig';
const ROOT_BACKGROUND_ID = ThemeDomEnum.ROOT_ID;
const DEFAULT_VALUE = 'default';
const DEFAULT_BACKGROUND_CONFIG = { layout: DEFAULT_VALUE, theme: DEFAULT_VALUE };
const cachedBackground = JSON.parse(localStorage.getItem(LOCALE_STORAGE_KEY)) || {};
// Priority: localStorage(non-empty) > window.config.clientVisual > DEFAULT
const defaultBackgroundConfig = isEmpty(cachedBackground) ?
	(window.config?.clientVisual || DEFAULT_BACKGROUND_CONFIG) :
	cachedBackground;
const setRootTheme = (themeId = DEFAULT_THEME_ID) => {
	const el = document.getElementById(ROOT_BACKGROUND_ID);

	if (el) {
		el.dataset.theme = themeId;
	}

	document.documentElement.dataset.theme = themeId;
	document.body.dataset.theme = themeId;
};
const settingBackground = (backgroundConfig = defaultBackgroundConfig) => {
	const rootBackgroundElement = document.querySelector(`#${ROOT_BACKGROUND_ID}`);

	if (!rootBackgroundElement) {
		return;
	}

	const themeId = resolveThemeId(backgroundConfig?.theme);

	setRootTheme(themeId);
};

export {
	ROOT_BACKGROUND_ID,
	LOCALE_STORAGE_KEY,
	settingBackground,
};
